module.exports = __webpack_public_path__ + "img/default.fc6015a.png";